import { v4 as uuidv4 } from "uuid";
import { createEmptyGroup } from "../../../../../components/queryBuilder/queryBuilderUtils";
import type {
  CallingRuleAction,
  CallingRuleDoc,
  CallingRuleFormData,
  CallingRuleState,
  CallingRuleTrigger,
} from "../../callingConfiguration/callingRuleUtils";
import {
  buildCallingConditionConfigFromCmmColumns,
  CALLING_CONDITION_FIELD_OPTIONS,
  mapCallingDocToRuleStates,
  mapRuleStatesToFirestorePayload,
} from "../../callingConfiguration/callingRuleUtils";

export const FIRST_STP_REVIEW_CONDITION_FIELD_OPTIONS =
  CALLING_CONDITION_FIELD_OPTIONS;

export type FirstStpReviewRuleAction = CallingRuleAction;
export type FirstStpReviewRuleTrigger = CallingRuleTrigger;
export type FirstStpReviewRuleDoc = CallingRuleDoc;
export type FirstStpReviewRuleState = CallingRuleState;
export type FirstStpReviewRuleFormData = CallingRuleFormData;

export const DEFAULT_FIRST_STP_REVIEW_DOC_ID = "first_stp_review";

export const DEFAULT_FIRST_STP_DOC_TRIGGERS: CallingRuleTrigger[] = [
  { type: "before_stp" },
];

export const FIRST_STP_REVIEW_CONDITION_TITLE = "First STP review condition";

export {
  buildCallingConditionConfigFromCmmColumns as buildFirstStpReviewConditionConfigFromCmmColumns,
  mapCallingDocToRuleStates as mapFirstStpReviewDocToRuleStates,
};

/** Resolve document-level triggers for first STP review configs. */
export function resolveFirstStpDocTriggers(
  doc: FirstStpReviewRuleDoc,
): FirstStpReviewRuleTrigger[] {
  if (doc.triggers?.length) {
    return doc.triggers.map((t) => ({ ...t }));
  }
  for (const rule of doc.rules ?? []) {
    if (rule.triggers?.length) {
      return rule.triggers.map((t) => ({ ...t }));
    }
  }
  return DEFAULT_FIRST_STP_DOC_TRIGGERS.map((t) => ({ ...t }));
}

export const mapFirstStpReviewRuleStatesToFirestorePayload = (
  rules: FirstStpReviewRuleState[],
  triggers: FirstStpReviewRuleTrigger[],
  existingDoc: FirstStpReviewRuleDoc | null,
  updatedBy?: string | null,
) => mapRuleStatesToFirestorePayload(rules, triggers, existingDoc, updatedBy);

/** Default empty rule for first STP review (needs_review set via actions). */
export function createEmptyFirstStpReviewRule(
  index: number,
): FirstStpReviewRuleState {
  return {
    id: `first-stp-review-rule-${uuidv4()}`,
    label: `Rule ${index + 1}`,
    subtext: "",
    active: true,
    actions: [
      { type: "set", field: "needs_review", value: "Needed" },
      { type: "set", field: "review_reason", value: "" },
    ],
    condition: createEmptyGroup(),
    conditionKey: "rule",
  };
}

/** Seed state when the Firestore document has no rules yet. */
export const getDefaultFirstStpReviewRules = (): FirstStpReviewRuleState[] => [
  createEmptyFirstStpReviewRule(0),
];
